import BaseView from 'components-framework/view/base.view';
import withRenderedMain from 'components-framework/view/with_rendered_main';
import getTokensFromUrl from 'od-modules/helpers/membership/get_renewal_reactivation_tokens_from_url';

export default withRenderedMain(
    BaseView.extend({
        initialize() {
            this.setListeners();
            this.setTokens();
        },

        setListeners() {
            this.listenTo(this.model, 'change:infoToken', this.sendInfoToken);
            this.listenTo(this.model, 'change:optOut', this.onSuccess);
            this.listenTo(this.model, 'change:error', this.onError);
        },

        setTokens() {
            this.model.set(getTokensFromUrl());
        },

        sendInfoToken() {
            this.model.sendInfoToken();
        },

        getCrmUrl() {
            const CRM_URL_OPT = this.model.getCrmUrlOpt();
            const CRM_UTM_PARAM = this.model.getCrmUtmParams();
            return `${CRM_URL_OPT}${this.model.get('crmToken')}${CRM_UTM_PARAM}`;
        },

        onSuccess() {
            window.location.replace(this.getCrmUrl());
        },

        onError() {
            Odigeo.Utils.goToApplicationHome();
        },
    })
);
